import {ESCAPE_KEY_CODE, KEY_VALUES} from 'common/util/dom';
import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';
import timing from '../../stylesheets/mixins/timing.json';

import css from './index.styl?inline';
import template from './index.jade';

export default class Drawer extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'not-fullscreen': `string`,
      open: `boolean`,
      placement: {type: `string`, default: `right`},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        delayRemove: timing[`$mp-fast`],
        placement: ``,
      },
      helpers: {
        close: () => this.dispatchEvent(new CustomEvent(`close`)),
        handleDrawerInsert: () => {
          this.dismissDrawer = ({defaultPrevented, key, keyCode}) => {
            // for browser compat. see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
            if (!defaultPrevented && (key === KEY_VALUES.ESCAPE || keyCode === ESCAPE_KEY_CODE)) {
              this.helpers.close();
            }
          };
          document.body.addEventListener(`keydown`, this.dismissDrawer, true);
        },
        handleDrawerDestroy: () => document.body.removeEventListener(`keydown`, this.dismissDrawer, true),
      },
    };
  }

  attributeChangedCallback(name, oldVal, newVal) {
    super.attributeChangedCallback(name, oldVal, newVal);

    if (!this.attr(`not-fullscreen`)) {
      if (this.attr(`open`)) {
        document.querySelector(`body`).classList.add(`no-scroll`);
      } else {
        document.querySelector(`body`).classList.remove(`no-scroll`);
      }
    }

    this.update({placement: this.attr(`placement`)});
  }
}

registerMPElement(`mp-drawer`, Drawer);
